import extractHighlightedText from "../extractHighlightedText";

const getTextChunksByParentElement = (highlightedText = [], annotation) => {
  if (!highlightedText.length) return [];

  const chunks = [];

  highlightedText.forEach((textNode, index) => {
    const isFirstNode = index === 0;
    const isLastNode = index === highlightedText.length - 1;
    const text = extractHighlightedText(
      textNode,
      annotation,
      isFirstNode,
      isLastNode,
    );

    const node = { ...textNode, text, isFirstNode, isLastNode };
    const previousNode = index !== 0 ? highlightedText[index - 1] : null;

    // Spans do not require a separate chunk, and should be rendered inline.
    const removeSpanFromIdentifier = (identifier) =>
      identifier?.replace(/\/span\[\d\]/, "");
    const previousNodeBlockParentIdentifier = removeSpanFromIdentifier(
      previousNode?.parentIdentifier,
    );
    const currentNodeBlockParentIdentifier = removeSpanFromIdentifier(
      textNode?.parentIdentifier,
    );

    const isNewChunk =
      index === 0 ||
      previousNodeBlockParentIdentifier !== currentNodeBlockParentIdentifier;

    if (isNewChunk) {
      const chunk = [node];
      chunks.push(chunk);
    } else {
      const currentChunkIndex = chunks.length - 1;
      chunks[currentChunkIndex].push(node);
    }
  });

  return chunks;
};

export default getTextChunksByParentElement;
